'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SuccessfulModal = require('./SuccessfulModal');

Object.defineProperty(exports, 'SuccessfulModal', {
  enumerable: true,
  get: function get() {
    return _SuccessfulModal.SuccessfulModal;
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/index.js
// module id = 1795
// module chunks = 0